module.exports = __webpack_public_path__ + "static/media/swapGrey.fb1f766d.svg";